import { ProcessedCourse, ProcessedCourseSubject } from "@/common/course/types";

//Hard coded values from old repo code
const jsonCourses = [
  {
    uuid: "f89c9ea8-b0ad-4c0c-8347-1b61dbd25125",
    cardType: "program_course",
    courseCount: 10,
  },
  {
    uuid: "5d105dab-e2a7-45c0-8663-3b84ada94762",
    cardType: "program_course",
    courseCount: 11,
  },
];
//Hard coded values from old repo code
const jsonSubjects = [
  {
    uuid: "a168a80a-4b6c-4d92-9f1d-4c235206feaf",
    slug: "data-science",
    inEdx: false,
  },
  {
    uuid: "e52e2134-a4e4-4fcb-805f-cbef40812580",
    inEdx: false,
  },
  {
    uuid: "409d43f7-ff36-4834-9c28-252132347d87",
    inEdx: false,
  },
  {
    uuid: "605bb663-a342-4cf3-b5a5-fee2f33f1642",
    inEdx: false,
  },
];

const setProcessedCourseOverrides = (course: ProcessedCourse) => {
  jsonCourses.forEach((overrideItem) => {
    if (overrideItem.uuid === course.id) {
      if (overrideItem.cardType) {
        course.cardType = overrideItem.cardType;
      }
      if (overrideItem.courseCount) {
        course.courseCount = overrideItem.courseCount;
      }
    }
  });
  if (course.subjects) {
    course.subjects = course.subjects.map((subject) => {
      const processedSubject = subject as ProcessedCourseSubject;
      jsonSubjects.forEach((overrideItem) => {
        if (overrideItem.uuid === processedSubject.uuid) {
          if (overrideItem.slug) {
            processedSubject.slug = overrideItem.slug;
          }
          if (overrideItem.inEdx) {
            processedSubject.inEdx = overrideItem.inEdx;
          }
        }
      });
      return processedSubject;
    });
  }
};

export default setProcessedCourseOverrides;
